module.exports = __webpack_public_path__ + "img/linkIcon.dc2308bc.svg";